const frontPartitionConfigs = [
	{
		configs: {
			PARTITION_NAME: 'QHS',
			PARTITION_URN: '$:partition:partition:1',
		},
		hostnames: ['siv2.qhs.fr', /.*siv2-qhs-fr\..+/i, 'localhost', '127.0.0.1'],
	},
	{
		configs: {
			PARTITION_NAME: 'DICOP',
			PARTITION_URN: '$:partition:partition:2',
		},
		hostnames: ['si.dicop.fr', /.*si-dicop-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'HPR',
			PARTITION_URN: '$:partition:partition:3',
		},
		hostnames: ['si.compagnie-hpr.com', /.*si-compagnie-hpr-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'HPRA',
			PARTITION_URN: '$:partition:partition:4',
		},
		hostnames: ['sia.compagnie-hpr.com', /.*sia-compagnie-hpr-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'CG2D',
			PARTITION_URN: '$:partition:partition:5',
		},
		hostnames: ['si.cg2d.fr', /.*si-cg2d-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'RCONTROLCLIM',
			PARTITION_URN: '$:partition:partition:6',
		},
		hostnames: ['si.rcontrolclim.fr', /.*si-rcontrolclim-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'IGIENAIR',
			PARTITION_URN: '$:partition:partition:7',
		},
		hostnames: ['si.igienair.com', /.*si-igienair-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'ADIAMS',
			PARTITION_URN: '$:partition:partition:8',
		},
		hostnames: ['si.adiams.com', /.*si-adiams-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'AIRSN',
			PARTITION_URN: '$:partition:partition:9',
		},
		hostnames: ['si.airsn.fr', /.*si-airsn-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'MAPCLIM',
			PARTITION_URN: '$:partition:partition:10',
		},
		hostnames: ['si.mapclim.fr', /.*si-mapclim-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'D2H',
			PARTITION_URN: '$:partition:partition:11',
		},
		hostnames: ['si.d2h-ventilation.com', /.*si-d2h-ventilation-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'ZAACK',
			PARTITION_URN: '$:partition:partition:12',
		},
		hostnames: ['si.zaack.io', /.*si-zaack-io\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'NANOSENSE',
			PARTITION_URN: '$:partition:partition:13',
		},
		hostnames: ['si.nano-sense.com', /.*si-nano-sense-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'ADDD',
			PARTITION_URN: '$:partition:partition:14',
		},
		hostnames: ['si.addd.fr', /.*si-addd-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'AGETEP',
			PARTITION_URN: '$:partition:partition:15',
		},
		hostnames: ['si.agetep.com', /.*si-agetep-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'IGC',
			PARTITION_URN: '$:partition:partition:16',
		},
		hostnames: ['aura-igc.igienair.com', /.*aura-igc-igienair-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'INTER',
			PARTITION_URN: '$:partition:partition:17',
		},
		hostnames: ['aura-inter.igienair.com', /.*aura-inter-igienair-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'AIRPLUSNETOUEST',
			PARTITION_URN: '$:partition:partition:18',
		},
		hostnames: ['aura.airplusnetouest.fr', /.*aura-airplusnetouest-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'SDNA',
			PARTITION_URN: '$:partition:partition:19',
		},
		hostnames: ['aura.sdna.fr', /.*aura-sdna-fr\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'IGIENAIR MONACO',
			PARTITION_URN: '$:partition:partition:20',
		},
		hostnames: ['aura-monaco.igienair.com', /.*aura-monaco-igienair-com\..+/i],
	},
	{
		configs: {
			PARTITION_NAME: 'HYES',
			PARTITION_URN: '$:partition:partition:21',
		},
		hostnames: ['aura.hyes.fr', /.*aura-hyes-fr\..+/i],
	},
];

const getConfig = configs => {
	const config = configs.find(config => {
		return config.hostnames.find(hostname => {
			if (typeof hostname === 'string') {
				return hostname === location.hostname;
			} else if (hostname instanceof RegExp) {
				return hostname.test(location.hostname);
			} else {
				throw `Invalid hostname ${hostname}`;
			}
		});
	});

	if (!config) {
		throw `Config not found for hostname ${location.hostname}`;
	}

	return config.configs;
};

const FrontPartitionConfig = getConfig(frontPartitionConfigs);

export default FrontPartitionConfig;
